export function addMobileNav() {

  const burgerButton = document.querySelector('.header__burger')
  const mobileNav = document.querySelector('.main__header')
  const listItems = Array.from(mobileNav.querySelectorAll('li'))

  burgerButton.addEventListener('click', ()=> {

    let count = 0

    mobileNav.classList.toggle('open')
    burgerButton.classList.toggle('open')

    listItems.forEach((e)=> {
      setTimeout(() => {
        e.classList.toggle('visible')
      }, count * 50)
      count++
    })

  })
}



// WEBPACK FOOTER //
// ./src/mobile-nav.js